import fetch from 'isomorphic-fetch';
import { checkStatus } from '../../util';
import { ROOT } from '../../../constants/root';

export function getThemes() {
	return function(dispatch, getState) {		

		const URL = `${ROOT}/theme/`;		

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(setThemesList(json));
		})
		.catch((e) => {
			console.error(e);			
		});
	};
}

function setThemesList(themes) {
	return {
		type: "SET_THEMES_LIST",
		themes
	};	
}


// WEBPACK FOOTER //
// ./src/state/domains/themes/actions.js